import type { HeaderV3Props } from '@jouzen/ecom-components';
import { type DynamicConfig, useConfig } from 'statsig-react';

interface HeaderLinkProps extends Omit<DynamicConfig, 'value'> {
  value: {
    headerLinks: HeaderV3Props['headerLinks'];
  };
}

const useHeaderConfig = (): HeaderV3Props['headerLinks'] => {
  const { config } = useConfig('global_header_links');
  const headerConfigValue = config.value as HeaderLinkProps['value'];
  const activeHeaderConfig = Object.keys(headerConfigValue).length > 0;

  if (!activeHeaderConfig) {
    return undefined;
  }

  return headerConfigValue.headerLinks;
};

export default useHeaderConfig;
